export const WEIGHT_UNITS = { 1: 'kg', 2: 'Man', 3: 'Man21', 4: 'Quintal', 5: 'Ton' };
export const AREA_UNITS = { 1: 'Guntha', 2: 'Bigha', 3: 'Acre', 4: 'Hectare', 5: 'Sq Feet', 6: 'Sq Meter' };
export const PAYMENT_STATUS = { paid: 'Paid', unpaid: 'Unpaid', na: 'N/A' };
export const CROP_STATUS = { 0: 'All', 1: 'Active', 2: 'Harvested' };

export const IMAGE_BASE = 'https://app3.khethisab.shop';
export const USER_IMAGE = (f) => `${IMAGE_BASE}/user_image/${f}`;
export const EXPENSE_PHOTO = (f) => `${IMAGE_BASE}/expanse_photo/${f}`;
export const SELLING_PHOTO = (f) => `${IMAGE_BASE}/selling_photo/${f}`;
export const CROP_PHOTO = (f) => `${IMAGE_BASE}/crop_photos/${f}`;
export const FARM_PHOTO = (f) => `${IMAGE_BASE}/selling_photo/${f}`;
export const CROP_NAME_IMAGE   = (f) => `${IMAGE_BASE}/crop_name_image/${f}`;
export const PAYMENT_LOG_IMAGE = (f) => `${IMAGE_BASE}/payment_logs/${f}`;
export const DISEASE_IMAGE     = (f) => `${IMAGE_BASE}/disease_images/${f}`;

export const SUPPORTED_LANGS = [
  { code: 'en', label: 'English' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'gu', label: 'ગુજરાતી' },
  { code: 'mr', label: 'मराठी' },
  { code: 'te', label: 'తెలుగు' },
  { code: 'ta', label: 'தமிழ்' },
  { code: 'bn', label: 'বাংলা' },
  { code: 'ur', label: 'اردو' },
];
